import { BehaviorSubject } from "rxjs";
import { AlertDefaults, IncidentType, MessageSettings, PriorityType } from "src/app/hickory-api";
import { deepCopy } from "src/app/shared/model/utility";
import { AlertModelService } from "../alert-model.service";
import { AlertDefaultsHelper } from "./alert-defaults-helper";
import { AlertFields } from "./alert-fields-helper";
import { LogHelper } from "src/app/shared/logging/log-helper";

const tag = 'Alert.Priority';

export class AlertPriorityHelper {

  static preparePreview(_service: AlertModelService, preview: AlertDefaults) {
    // ROAD-6671: ensure that message.priority is set properly (incident priority takes precedence)
    const message = preview.message;
    if (message) {
      message.priority = this.getAlertPriority(message);
    }
  }

  static getAlertPriority(message?: MessageSettings): PriorityType {
    if (!message) return null;
    return this.getOptionalAlertPriority(message) ?? PriorityType.Emergency;
  }

  static getOptionalAlertPriority(message?: MessageSettings): PriorityType {
    if (!message) return null;
    if (message.incidentEvent) {
      if (message.incidentEvent.incidentType?.classification === IncidentType.ClassificationEnum.Operations) {
        return PriorityType.NonEmergency;
      } else {
        return PriorityType.Emergency;
      }
    }

    return message.incident?.priority ?? message.priority;
  }

  static onPriorityChange(service: AlertModelService, alert: AlertDefaults, update: PriorityType, callback?: BehaviorSubject<unknown>): boolean {
    if (!alert || !update) return false;
    if (this.getOptionalAlertPriority(alert.message) === update) return false;
    LogHelper.debug(tag, 'on change:', update);

    if (service.useAlertPriorityV2) {
      const alertCopy = deepCopy(alert);
      AlertDefaultsHelper.initDefaults(alertCopy);
      alertCopy.message.priority = update;
      service.fetchDefaults(alertCopy, AlertFields.PRIORITY, callback);
    } else {
      alert.message.priority = update;
      service.notifyFieldUpdated(AlertFields.PRIORITY);
      callback?.next(alert);
    }

    return true;
  }

}
